function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "97.506%",
  id: "People_svg__20_a"
}, React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0.304,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.953 42.928a29.76 29.76 0 010 3.143c.9 13.305-3.293 26.459-11.75 36.861a10.536 10.536 0 00.27 7.546c21.163 7.69 32.84 13.311 37.48 22.527.692 1.394 1.403 3.506 2.132 6.337 1.652 6.418-2.212 12.96-8.63 14.612a12 12 0 01-2.991.38h-94.106c-6.627 0-12-5.373-12-12a12 12 0 01.377-2.983c.734-2.862 1.45-4.995 2.147-6.397 4.64-9.175 16.316-14.806 37.656-22.609a10.96 10.96 0 00-.084-7.67c-8.352-10.349-12.48-23.406-11.572-36.605-.88-16.637 12.078-30.827 28.942-31.695 16.865-.868 31.249 11.916 32.129 28.553zm55.242 7.594c.043.804.043 1.61 0 2.413.69 10.216-2.52 20.316-8.994 28.304a8.112 8.112 0 00.206 5.794c16.202 5.905 25.141 10.22 28.693 17.297.53 1.07 1.074 2.692 1.632 4.865 1.265 4.929-1.693 9.952-6.606 11.22a9.16 9.16 0 01-2.29.292H62.41a17.152 17.152 0 00-.462-2.618c-.808-3.14-1.62-5.552-2.498-7.32l-.154-.301c-3.923-7.572-10.859-12.766-24.95-18.804 3.456-1.511 7.448-3.057 12.018-4.733a8.438 8.438 0 00-.063-5.889c-6.395-7.947-9.555-17.972-8.86-28.107C36.77 40.16 46.69 29.265 59.6 28.598c12.91-.666 23.922 9.15 24.595 21.924z",
  transform: "translate(0 -14)",
  fill: "url(#People_svg__20_a)",
  fillRule: "nonzero"
});

var SvgPeople = function SvgPeople(props) {
  return React.createElement("svg", _extends({
    width: 106,
    height: 117,
    viewBox: "0 0 106 117"
  }, props), _ref, _ref2);
};

export default SvgPeople;